import script from "./common-table.vue?vue&type=script&setup=true&lang=js"
export * from "./common-table.vue?vue&type=script&setup=true&lang=js"

import "./common-table.vue?vue&type=style&index=0&id=390b6200&lang=scss"

const __exports__ = script;

export default __exports__